"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formatters_1 = require("../../formatters");

var subscriptions_1 = require("../../subscriptions");

function subscribeForLogs(eth) {
  var logRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var fromBlock = logRequest.fromBlock,
      subscriptionLogRequest = _objectWithoutProperties(logRequest, ["fromBlock"]);

  var params = [formatters_1.toRawLogRequest(subscriptionLogRequest)];
  var subscription = new subscriptions_1.Subscription('eth', 'logs', params, eth.provider, function (result, sub) {
    var output = formatters_1.fromRawLogResponse(result);
    sub.emit(output.removed ? 'changed' : 'data', output, sub);
  }, false);

  if (fromBlock !== undefined) {
    eth.getPastLogs(logRequest).then(function (logs) {
      logs.forEach(function (log) {
        return subscription.emit('data', log, subscription);
      });
      subscription.subscribe();
    }).catch(function (err) {
      subscription.emit('error', err, subscription);
    });
  } else {
    subscription.subscribe();
  }

  return subscription;
}

exports.subscribeForLogs = subscribeForLogs;